import './tree.sass';

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Translate } from 'react-redux-i18n';
import SortableTree, { getTreeFromFlatData, toggleExpandedForAll } from 'react-sortable-tree';

import TrackTitle from 'components/tracks-tree/track-title/TrackTitle';
import FolderTitle from 'components/tracks-tree/folder-title/FolderTitle';
import TrackControls from 'components/tracks-tree/track-controls/TrackControls';
import FolderControls from 'components/tracks-tree/folder-controls/FolderControls';

import ContentLoader from 'controls/content-loader/ContentLoader';

import request from 'actions/request';
import transmit from 'actions/transmit';

const MAX_DEPTH = 5;
const TRACK_TYPE = 'track';
const FOLDER_TYPE = 'folder';
const TOP_CONTROLS_HEIGHT = 105;

class Tree extends Component {
  constructor(props) {
    super(props);

    if (props.list) {
      this.state = {
        treeData: getTreeFromFlatData({
          flatData: this.prepareTreeData(props.list)
        })
      };
    }
  }

  componentWillReceiveProps(nextProps) {
    var middleware = (data) => data;

    if ((this.props.expanded !== nextProps.expanded)
      && (typeof nextProps.expanded === 'boolean')
    ) {
      middleware = (data) => {
        return toggleExpandedForAll({
          treeData: data,
          expanded: nextProps.expanded
        });
      }
    }

    let nextPropsList = nextProps.list.map((item) => {
      if (item.type === 'folder') {
        return {
          ...item,
          id: item.id * -1,
          parentId: item.parentId * -1
        }
      } else if (item.type === 'track') {
        return {
          ...item,
          parentId: item.parentId * -1
        }
      }
    });

    this.setState({
      treeData: middleware(
        getTreeFromFlatData({
          flatData: this.prepareTreeData(nextPropsList)
        })
      )
    });
  }

  fetchDashboard() {
    this.props.request(
      ['folder', 'getAll'],
      'get',
      'FOLDERS'
    );
    this.props.request(
      ['tracks', 'getAll'],
      'get',
      'TRACKS'
    );
    this.props.request(
      ['users', 'getSettings'],
      'get',
      'USER_SETTINGS'
    );
  }

  componentDidMount() {
    this.resize();

    if (this.props.isAuthenticated && this.props.pending !== false) {
      this.fetchDashboard();
    } else {
      this.checkChosen();
      this.flightClickEventListenerAdd();
    }
  }

  checkChosen() {
    let rows = document.getElementsByClassName('tracks-tree-tree__item');
    for (var ii = 0; ii < rows.length; ii++) {
      rows[ii].classList.remove('is-chosen');
    }

    let tracks = document.getElementsByClassName('tracks-tree-tree__flight');
    this.props.chosenTracks.forEach((chosenTrack) => {
      for (var ii = 0; ii < tracks.length; ii++) {
        let flightRow = tracks[ii];
        let title = flightRow.getElementsByClassName('tracks-tree-track-title');
        let trackId = parseInt(title[0].getAttribute('data-track-id'));

        if (chosenTrack.id === trackId) {
          flightRow.classList.add('is-chosen');
        }
      };
    });
  }

  componentWillUnmount() {
    function removeEventListenerByClass(className, event, fn) {
      var list = document.getElementsByClassName(className);
      for (var ii = 0, len = list.length; ii < len; ii++) {
        list[ii][event] = '';
      }
    }

    removeEventListenerByClass(
      'rst__rowContents',
      'onclick'
    );
  }

  componentDidUpdate(prevProps) {
    if (!prevProps.isAuthenticated && this.props.isAuthenticated) {
      this.fetchDashboard();
    }

    this.resize();

    this.flightClickEventListenerAdd();

    let chosen = document.getElementsByClassName('is-chosen');
    if (this.props.chosenTracks.length !== chosen.length) {
      this.checkChosen();
    }
  }

  flightClickEventListenerAdd()
  {
    function addEventListenerByClass(className, event, fn) {
      var list = document.getElementsByClassName(className);
      for (var ii = 0, len = list.length; ii < len; ii++) {
        list[ii][event] = fn;
      }
    }

    addEventListenerByClass(
      'rst__rowContents',
      'onclick',
      this.handleItemClick.bind(this)
    );
  }

  handleItemClick(event) {
    let currentTarget = event.currentTarget;
    let target = event.target;

    function findAncestor (el, cls) {
      while ((el = el.parentElement) && !el.classList.contains(cls));
      return el;
    }

    if (target.classList.contains('tracks-tree-track-controls')
      || findAncestor(target, 'tracks-tree-track-controls')
    ) {
      return;
    }

    let flightRow = findAncestor(currentTarget, 'tracks-tree-tree__flight');

    // not a track. Maybe folder
    if (!flightRow) {
      return;
    }

    let title = flightRow.getElementsByClassName('tracks-tree-track-title');
    let trackId = parseInt(title[0].getAttribute('data-track-id'));

    flightRow.classList.toggle('is-chosen');
    this.props.transmit(
      'TRACKS_CHOISE_TOGGLE',
      {
        id: trackId,
        checkstate: flightRow.classList.contains('is-chosen')
      }
    );
  }

  resize(event) {
    this.container.style.height = window.innerHeight - TOP_CONTROLS_HEIGHT + 'px';
  }

  prepareTreeData(flatData) {
    if (!Array.isArray(flatData)) {
      return [];
    }

    flatData.forEach((item) => {
      if (item.type === TRACK_TYPE) {
        item.title = <TrackTitle track={ item }/>;
      } else if (item.type === FOLDER_TYPE) {
        item.title = <FolderTitle folderInfo={ item }/>;
      }
    });

    return flatData;
  }

  updateTreeData(treeData) {
    this.setState({ treeData });
  }

  moveNodeHandler({ node, treeIndex, path }) {
    let treeData = this.state.treeData;
    let id = node.id;
    let parent = { id: 0 }; // if not found than moved to root

    this.findParent(treeData, id, (found) => { parent = found });
    let data = { id: id, parentId: parent.id };

    if (node.type === 'folder') {
      data.id = id * -1;
    };

    if (parent.type === 'folder') {
      data.parentId = parent.id * -1;
    };

    if (node.type === TRACK_TYPE) {
      this.props.request(
        ['tracks', 'changePath'],
        'put',
        'TRACK_PATH',
        data
      );
    } else if (node.type === FOLDER_TYPE) {
      this.props.request(
        ['folder', 'changePath'],
        'put',
        'FOLDER_PATH',
        data
      );
    }
  }

  expandHandler({ treeData, node, expanded }) {
    this.props.request(
      ['folder', 'toggleExpanding'],
      'put',
      'FOLDER_EXPANDING',
      {
        id: node.id * -1,
        expanded: expanded
      }
    );
  }

  findParent(treeData, id, save) {
    treeData.forEach((item) => {
      let itemId = item.id;
      let children = item.children || [];

      children.forEach((childItem) => {
        if (childItem.id === id) {
          save(item)
        } else {
          this.findParent(children, id, save);
        }
      });
    });
  }

  buildTree() {
    return (<SortableTree
      rowHeight={ 50 }
      scaffoldBlockPxWidth={ 40 }
      maxDepth={ MAX_DEPTH }
      treeData={ this.state.treeData }
      onChange={ this.updateTreeData.bind(this) }
      onMoveNode={ this.moveNodeHandler.bind(this) }
      onVisibilityToggle={ this.expandHandler.bind(this) }
      canDrop={({ nextParent }) => !nextParent || !nextParent.noChildren}
      isVirtualized={ false }
      generateNodeProps={
        rowInfo => {
          if (rowInfo.node.type === TRACK_TYPE) {
            return {
              buttons: [ <TrackControls track={ rowInfo.node }/> ],
              className: 'tracks-tree-tree__item tracks-tree-tree__flight',
            }
          } else if (rowInfo.node.type === FOLDER_TYPE) {
            return {
              buttons: [ <FolderControls folderInfo={ rowInfo.node }/> ],
              className: 'tracks-tree-tree__item tracks-tree-tree__folder',
            }
          }
        }
      }
     />);
  }

  buildBody() {
    if (this.props.pending !== false) {
      return <ContentLoader/>
    } else {
      return this.buildTree();
    }
  }

  render() {
    return (
      <div className='tracks-tree-tree'
        ref={(container) => { this.container = container; }}
      >
        { this.buildBody() }
      </div>
    );
  }
}

function merge(tracks, folders) {
  if (Array.isArray(tracks) && Array.isArray(folders)) {
    return folders.concat(tracks);
  } else if (!Array.isArray(tracks) && Array.isArray(folders)) {
    return folders;
  } else if (Array.isArray(tracks) && !Array.isArray(folders)) {
    return tracks;
  } else {
    return [];
  }
}

function isPending(flightsPending, foldersPending, settingsPending) {
  return !((flightsPending === false)
    && (foldersPending === false)
    && (settingsPending === false)
  );
}

function mapStateToProps(state) {
  return {
    isAuthenticated: state.user.login !== null,
    pending: isPending(state.tracks.pending, state.folders.pending, state.settings.pending),
    list: merge(state.tracks.items, state.folders.items),
    chosenTracks: state.tracks.chosenItems,
    expanded: state.folders.expanded
  };
}

function mapDispatchToProps(dispatch) {
  return {
    request: bindActionCreators(request, dispatch),
    transmit: bindActionCreators(transmit, dispatch),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Tree);
